module.exports = __webpack_public_path__ + "static/media/SubhashRajpurohit.4c59f417.jfif";